import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { useSiteMetadataQuery } from '../../graphql/useSiteMetadataQuery'

const Seo = ({
  title,
  description = '',
  canonicalHref,
  hasDefaultTitle = true,
}) => {
  // TODO: retrieve site
  const data = useSiteMetadataQuery()
  const href = `${data.site?.siteMetadata?.siteUrl}${canonicalHref}`

  const defaultTitle = ' | Constellium'
  const metaTitle =
    title && hasDefaultTitle
      ? title + defaultTitle
      : title && !hasDefaultTitle
      ? title
      : defaultTitle
  return (
    <Helmet>
      <title>{metaTitle}</title>
      <meta name="description" content={description} />
      {canonicalHref && <link rel="canonical" href={href} />}
      <script>window.dataLayer = window.dataLayer || [];</script>
      <script>
        {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-W2LQXZV');`}
      </script>

      <noscript>
        {`
        <iframe
          title='gtm'
          src='https://www.googletagmanager.com/ns.html?id=GTM-W2LQXZV'
          height='0'
          width='0'
          style='display:none;visibility:hidden'
        ></iframe>
        `}
      </noscript>
    </Helmet>
  )
}

Seo.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string,
}

export default Seo
